import styled from 'styled-components';

export const TutorialPopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto 1.5rem;
  align-items: center;

  p {
    font: 400 1rem/1.5rem 'SegoeUI', sans-serif;
  }

  > svg {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }
`;
